import { DATA_POINT_PROXIMITY_THRESHOLD_MS, POINT_TIME_DIFFERENCE_THRESHOLD_MS, findClosestIndex, formatDisplayTimestamp, formatNumberBySignificantFigures } from './chartUtils'
import { measurementDefinitions } from './measurementDefinitions'

export const getFormattedTooltipHeader = (xTimestamp, chargeStageData, isLoading, error, CHARGE_STAGE_NAME_MAPPING) => {
  const formattedXValue = xTimestamp ? formatDisplayTimestamp(xTimestamp) : 'Date/Time N/A'
  let currentChargeStageDisplay = 'N/A'

  if (isLoading) {
    currentChargeStageDisplay = 'Loading...'
  } else if (error) {
    currentChargeStageDisplay = 'Error'
  } else if (typeof xTimestamp === 'number' && chargeStageData?.length) {
    const lastEvent = chargeStageData.findLast(
      stageEvent => new Date(stageEvent._time).getTime() <= xTimestamp,
    )
    if (lastEvent && lastEvent._value && CHARGE_STAGE_NAME_MAPPING) {
      currentChargeStageDisplay = CHARGE_STAGE_NAME_MAPPING[lastEvent._value] || String(lastEvent._value)
    }
  }

  return (
    `<div class="apexcharts-tooltip-title" style="font-family: inherit; font-size: 12px; padding-bottom: 4px; margin-bottom: 4px; border-bottom: 1px solid #ddd;">
      ${formattedXValue}<br>
      Charge Stage: ${currentChargeStageDisplay}
     </div>`
  )
}

export const getSeriesTooltipHtml = (seriesConfig, seriesIndex, w, xTimestamp, seriesMap) => {
  if (!seriesConfig || w.globals.collapsedSeriesIndices.includes(seriesIndex)) return ''

  const { colors, series, seriesX: allSeriesX } = w.globals
  const seriesName = seriesConfig.name || `Series ${seriesIndex + 1}`
  const seriesColor = colors[seriesIndex]
  const currentSeriesData = series[seriesIndex]
  const currentSeriesX = allSeriesX[seriesIndex]

  if (!currentSeriesData || !currentSeriesX) return ''

  const idx = findClosestIndex(currentSeriesX, xTimestamp)
  const yValue = idx !== -1 ? currentSeriesData[idx] : null

  if (idx === -1 || yValue == null || Math.abs(xTimestamp - currentSeriesX[idx]) > DATA_POINT_PROXIMITY_THRESHOLD_MS) {
    return (
      `<div class="apexcharts-tooltip-series" style="display: flex; align-items: center; padding: 3px 5px; opacity:0.5;">
        <span class="apexcharts-tooltip-marker" style="background-color:${seriesColor}; width: 10px; height: 10px; margin-right: 5px; border-radius: 50%;"></span>
        <div class="apexcharts-tooltip-text" style="font-family: inherit; font-size: 12px;">
          <span>${seriesName}: N/A (at this point)</span>
        </div>
      </div>`
    )
  }

  const formattedValue = typeof yValue === 'number' ? formatNumberBySignificantFigures(yValue) : String(yValue)
  const originalSeriesData = seriesMap.get(seriesName)
  const unit = measurementDefinitions[originalSeriesData?.measurementId]?.units || ''

  let pointTimeInfo = ''
  if (Math.abs(currentSeriesX[idx] - xTimestamp) > POINT_TIME_DIFFERENCE_THRESHOLD_MS) {
    const pointDate = new Date(currentSeriesX[idx])
    const timeOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }
    pointTimeInfo = ` (at ${pointDate.toLocaleTimeString(undefined, timeOptions)})`
  }

  return (
    `<div class="apexcharts-tooltip-series" style="display: flex; align-items: center; padding: 3px 5px;">
      <span class="apexcharts-tooltip-marker" style="background-color:${seriesColor}; width: 10px; height: 10px; margin-right: 5px; border-radius: 50%;"></span>
      <div class="apexcharts-tooltip-text" style="font-family: inherit; font-size: 12px;">
        <span>${seriesName}: ${formattedValue} ${unit}${pointTimeInfo}</span>
      </div>
    </div>`
  )
}
